import React, { useContext } from 'react';
import { Query } from 'react-apollo';
import { useParams } from 'react-router-dom';
import { Loading } from '../../components/Loading';
import { ACCOUNT_LIST } from '../../components/Query';
import { growlErrors } from '../../utils/NotificationUtil';
import UserDetailComponent from './UserDetailComponent';
import { NotificationContext } from '../../components/GrowlNotifications';

const getEdgeForCurrentAccount = (edges, currentAccountId) => {
  let edgeForCurrentAccount;

  edges.forEach((edge) => {
    const accountId = edge.node.id;

    if (accountId === currentAccountId) {
      edgeForCurrentAccount = edge;
    }
  });

  return edgeForCurrentAccount;
};

const UserComponent = () => {
  const growl = useContext(NotificationContext);

  const { aid: accountId, id: userId} = useParams();

  return (
    <Query query={ACCOUNT_LIST} variables={{ first: 100 }}>
      {({ loading, error, data }) => {
        if (loading) {
          return <Loading />;
        }
        if (error) {
          growlErrors(growl, error);
        }

        const { id, accounts } = data.viewer;
        const { edges } = accounts;

        const edgeForCurrentAccount = getEdgeForCurrentAccount(edges, accountId);

        const viewerRole = edgeForCurrentAccount.role;

        return (
          <UserDetailComponent
            viewerId={id}
            viewerRole={viewerRole}
            userId={userId}
            accountId={accountId}
          />
        );
      }}
    </Query>
  );
}


export default UserComponent;
